{
	"title": "Welke past op mijn wisser?",
	"description": "In drie stappen: meet je wisser, vind je houder en kies je navulling. Met de maten van elke houder en wat erop past.",
	"breadcrumbs": "Kruimelpad",
	"lead": "In drie stappen: meet je wisser, vind je houder, kies je navulling.",
	"measure": {
		"title": "Meet je wisser",
		"steps": {
			"look": "Leg de wisser op de grond en kijk van boven.",
			"length": { "before": "Meet de", "word": "lengte", "after": " van de voet, van links naar rechts." },
			"width": { "before": "Meet de", "word": "breedte", "after": ", van voor naar achter." }
		},
		"tip": "Meet de voet zelf, zonder doekje. Een Duster heeft geen voet: daar kijk je naar het handvat."
	},
	"find": {
		"title": "Vind je houder",
		"choose": "Kies je navulling",
		"foot": "Voet",
		"cloth": "Doekje",
		"fits": "Past op",
		"otherBrands": "andere merken",
		"perPiece": "vanaf {{price}} per {{noun}}",
		"perPieceExact": "{{price}} per {{noun}}",
		"onlyConfirmed": "Een merk staat er alleen bij als we de pasvorm zeker weten. De rest volgt na controle.",
		"empty": "Er staan nog geen houders in de winkel."
	},
	"noFit": {
		"title": "Wat niet past",
		"line": "passen niet op de {{holder}}.",
		"lineMany": "passen niet op {{holder}}."
	},
	"faq": {
		"title": "Vragen over de pasvorm",
		"all": "Alle veelgestelde vragen"
	}
}
